import Campaigns from "../../pages/Campaigns/Campaigns";
import NewCampaign from "../../pages/Campaigns/NewCampaign";
import NewCampaignMulti from "../../pages/Campaigns/NewCampaignMulti";
import NewCampaignRcs from "../../pages/Campaigns/rcs/NewCampaignRcs";
import _NewCampaignMulti from "../../pages/Campaigns/multi/_NewCampaignMulti";
import ShortLinks from "../../pages/Campaigns/ShortLinks";
import CampaignDetail from "../../pages/Campaigns/CampaignDetail";
import { createProtectedRoutes } from "../../utils/createdProtectedRoutes";

export const ROUTE = "Campaigns";

const routesConfig = [
  { path: `${ROUTE}/Campaigns`, component: Campaigns, roles: [1, 2, 3] },
  {
    path: `${ROUTE}/NewCampaignMulti`,
    component: NewCampaignMulti,
    roles: [1, 2, 3, 5],
  },
  {
    path: `${ROUTE}/NewCampaignRcs`,
    component: NewCampaignRcs,
    roles: [1, 2, 3, 5],
    channel: "RCS",
  },
  { path: `${ROUTE}/NewCampaign`, component: NewCampaign, roles: [1, 2, 3, 5] },
  {
    path: `${ROUTE}/NewCampaign/multi`,
    component: _NewCampaignMulti,
    roles: [1, 2, 3, 5],
  },
  { path: `ShortLinks`, component: ShortLinks, roles: [1, 2, 3] },
  { path: "Campaign/Details/:id", component: CampaignDetail, roles: [1, 2, 3] },
];

const campaignsRoutes = createProtectedRoutes(routesConfig);

export default campaignsRoutes;
